import { API_URL } from '../config/apiConfig';

export interface ImportBatch {
  id: string;
  source_file: string;
  total_rows: number;
  imported: number;
  updated: number;
  failed: number;
  skipped: number;
  started_at: string;
  completed_at: string | null;
  status: string;
}

export interface ImportLog {
  id: string;
  import_batch_id: string;
  hotel_name: string;
  hotel_id: string | null;
  status: string;
  step: string;
  error_message: string | null;
  source_file: string;
  row_number: number;
  warnings: string[];
  created_at: string;
}

export interface ImportStats {
  total_batches: number;
  total_imported: number;
  total_updated: number;
  total_failed: number;
  hotels_with_estimated_rooms: number;
  hotels_without_email: number;
  data_completeness_percent: number;
}

const getHeaders = () => {
  const token = localStorage.getItem('cns_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const importMonitorService = {
  async getBatches(): Promise<ImportBatch[]> {
    try {
      const res = await fetch(`${API_URL}/api/admin/import/batches`, { headers: getHeaders() });
      if (!res.ok) throw new Error('Failed to fetch batches');
      const data = await res.json();
      return data.batches || [];
    } catch {
      return [];
    }
  },

  async getBatchLogs(batchId: string): Promise<ImportLog[]> {
    try {
      const res = await fetch(`${API_URL}/api/admin/import/batches/${batchId}/logs`, { headers: getHeaders() });
      if (!res.ok) throw new Error('Failed to fetch logs');
      const data = await res.json();
      return data.logs || [];
    } catch {
      return [];
    }
  },

  async getStats(): Promise<ImportStats> {
    try {
      const res = await fetch(`${API_URL}/api/admin/import/stats`, { headers: getHeaders() });
      if (!res.ok) throw new Error('Failed to fetch stats');
      return await res.json();
    } catch {
      return {
        total_batches: 0, total_imported: 0, total_updated: 0,
        total_failed: 0, hotels_with_estimated_rooms: 0,
        hotels_without_email: 0, data_completeness_percent: 0,
      };
    }
  },
};
